import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  width: 160px;
  height: calc(100% + 100px);
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
`;

export const ProductItem = styled(Link)`
  padding: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background: #3ec4b8;
    color: #ffffff;
    span,
    em {
      color: #ffffff;
    }
  }

  background: ${(props) => (props.active ? '#3ec4b8' : '#FFFFFF')};
  color: ${(props) => (props.active ? '#FFFFFF' : '#171717')};

  div {
    display: flex;
    flex-direction: column;

    span {
      font-family: 'Lato', sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: ${(props) => (props.active ? '#FFFFFF' : '#171717')};
    }

    em {
      font-size: 15px;
      font-style: normal;
      color: ${(props) => (props.active ? '#FFFFFF' : '#171717')};
    }
  }
`;
